import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const LogoSlider = () => {
  const settings = {
    dots: false, 
    infinite: true, 
    speed: 500, 
    slidesToShow: 5,
    slidesToScroll: 1, 
    autoplay: true, 
    autoplaySpeed: 2000, 
    arrows: false, 
    responsive: [
      {
        breakpoint: 1024, 
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600, 
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, 
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  
  const logos = [
    "/images/Logos/1.jpg",
    "/images/Logos/2.jpg",
    "/images/Logos/3.jpg",
    "/images/Logos/4.jpg",
    "/images/Logos/5.jpg",
    "/images/Logos/6.jpg",
    "/images/Logos/7.jpg",
    "/images/Logos/8.jpg",
    "/images/Logos/9.jpg",
    "/images/Logos/10.jpg",



   
  ];

  return (
    <>
    
     <div className="inner-title-box">
              <h2 className="p-2 darkcolorrr">OUR HAPPY CLIENTS</h2>
            </div>
    <div className="logo-slider pb-3 border py-2">
      <Slider {...settings}>
        {logos.map((logo, index) => (
          <div key={index} className="logo-slide">
            <img src={logo} alt={`Logo ${index + 1}`} style={{ maxWidth: "100%", height: "auto" }} />
          </div>
        ))}
      </Slider>
    </div>
    </>
  );
};

export default LogoSlider;
